import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { CheckIcon } from '@calendly/ui/components/icons';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import BillingClickCapture from 'components/billing/click_capture';
import { ContactLink } from './contact_link';
const containerCss = "c72zdmq";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const headerCss = "hj6eg8b";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const cardCss = "c1rp93io";
const Card = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(cardCss, props.className)} />);
const cardBodyCss = "cd3gq1k";
const CardBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardBodyCss, props.className)} />;
});
const cardFooterIsPhoneCss = "c16eru5c";
const cardFooterCss = "cxuxn8z";
const CardFooter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(cardFooterCss, {
    [cardFooterIsPhoneCss]: isPhone
  }, props.className)} />;
});
const optionsCss = "ohr1pyp";
const Options = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(optionsCss, props.className)} />;
});
const itemCss = "iluq9k3";
const Item = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(itemCss, props.className)} />;
});
const UpgradeButton = ({
  children,
  featureKey
}) => <BillingClickCapture featureName={featureKey}>
    <Button>
      {children}
    </Button>
  </BillingClickCapture>;
const Option = ({
  children
}) => <Item>
    <CheckIcon inline />
    <BodyText inline>{children}</BodyText>
  </Item>;
export const IntroState = () => <>
    <Header>{HtmlParser(I18n.t('publisher.organization.managed_event_types.intro_state.header'))}</Header>
    <Container>
      <Card>
        <CardBody>
          <HeadingText variant="eyebrow">{I18n.t('publisher.organization.managed_event_types.intro_state.card.header')}</HeadingText>
          <Options>
            <Option>{I18n.t('publisher.organization.managed_event_types.intro_state.card.point_1')}</Option>
            <Option>{I18n.t('publisher.organization.managed_event_types.intro_state.card.point_2')}</Option>
            <Option>{I18n.t('publisher.organization.managed_event_types.intro_state.card.point_3')}</Option>
            <Option>{I18n.t('publisher.organization.managed_event_types.intro_state.card.point_4')}</Option>
          </Options>
        </CardBody>
        <CardFooter>
          <UpgradeButton featureKey="managed_events">
            {I18n.t('publisher.organization.managed_event_types.intro_state.card.upgrade_button')}
          </UpgradeButton>
          <BodyText>
            {HtmlParser(I18n.t('publisher.organization.managed_event_types.intro_state.card.enterprise_section'), {
            ContactLink
          })}
          </BodyText>
        </CardFooter>
      </Card>
    </Container>
  </>;

require("./intro_state.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./intro_state.js");